export function getRegeneratingPrompt(template: string, missingData: any): string {
    const missingDataCommaSeperated = Array.isArray(missingData)
        ? missingData.join(", ")
        : "";

    // Replace placeholders in the template
    return template
        .replace("<missing-data-comma-seperated>", missingDataCommaSeperated)
}